// Page keys must match backend ALL_PAGES in server.py
export const PAGES = [
  ["dashboard", "Dashboard"],
  ["roster", "Rostering"],
  ["enquiries", "Enquiries"],
  ["clients", "Clients"],
  ["staff", "Staff & befrienders"],
  ["incidents", "Incidents"],
  ["billing", "Billing"],
  ["payroll", "Payroll"],
  ["families", "Family access"],
  ["activity", "Activity log"],
  ["policies", "Policies"],
  ["inbox", "Inbox"],
  ["trash", "Recycle bin"],
  ["leave", "Leave & holidays"],
  ["compliance", "Compliance"],
  ["training", "Training"],
];

export const pageOf = (to) => (to === "/" ? "dashboard" : to.slice(1));
